export default __webpack_public_path__ + "static/media/100_15216.64283b32.jpg";